import { Menu } from "../components/navbar";
import { useAuthStore } from "../stores/auth";

export function useProfileMenu(): Menu[] {
  const isAuth = useAuthStore((state) => state.isAuth);

  return [
    ...(isAuth
      ? [
          {
            title: "Logout",
            slug: "/logout",
          },
        ]
      : []),
  ];
}
